export default __webpack_public_path__ + "static/media/img_pdf.e69db86a.svg";